export const process = {
    env: {
        OPENAI_API_KEY: "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"
    }
}